var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerformance = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 77,
    viewBox: "0 0 71 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 43.3799,
    width: 15.1831,
    height: 33.6197,
    fill: "#FFF2D3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4375,
    y: 26.0283,
    width: 15.1831,
    height: 50.9718,
    fill: "#FFF2D3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.873,
    width: 15.1831,
    height: 77,
    fill: "#FFF2D3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.3105,
    y: 26.0283,
    width: 15.1831,
    height: 50.9718,
    fill: "#FFF2D3"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerformance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/performance.917c75b0d114b840cbef00cd0525c413.svg";